exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#calculator-common {\n  font-family: var(--font-family-normal);\n}\n", ""]);

// exports
